var _desc, _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDefaultProfileAvatar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "140px",
    height: "140px",
    viewBox: "0 0 140 140",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Avatar (No Photo Int, Default)") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    x: 0,
    y: 0,
    width: 140,
    height: 140
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Artboard"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Avatar-(No-Photo-Int,-Default)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#262626",
    x: 0,
    y: 0,
    width: 140,
    height: 140
  }), /*#__PURE__*/React.createElement("g", {
    id: "_Avatar"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#262626",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask-2)",
    fill: "#666666",
    id: "Fill-1"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000, 16.666667)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M128.907462,116.939944 C115.740346,110.237154 96.4819004,102.488975 96.4819004,102.488975 C96.4819004,102.488975 85.0060821,98.1234297 85.6828965,87.2179294 C85.6942177,87.0368926 85.7833111,86.8686464 85.9235963,86.7535306 C92.0941744,81.6982743 96.412004,73.8069386 97.4555287,64.7132822 C97.4643888,64.6375223 97.4865391,64.5652059 97.5224718,64.4978091 C97.5849848,64.3807255 97.6470056,64.2616741 97.708042,64.1386871 C97.7277311,64.0998233 97.7464358,64.0589916 97.7656327,64.0201277 C100.311439,64.4545177 103.300744,60.6128968 104.826652,55.3028115 C106.403261,49.8166089 106.221136,45.4230225 103.267764,45.4230225 C103.195899,45.4230225 103.123049,45.4244983 103.050199,45.426958 C102.651986,45.4422084 102.336468,45.0963691 102.377815,44.700351 C103.047738,38.2607535 103.040355,33.150891 103.039863,33.1253097 L103.039863,33.1243258 C103.039863,14.8302604 88.2011381,0 69.896632,0 C51.5921258,0 36.7534015,14.8302604 36.7534015,33.1243258 C36.7534015,33.1243258 36.7440491,38.2425514 37.415449,44.6964155 C37.4567962,45.0939093 37.1383243,45.4235144 36.7386346,45.4230225 L36.7312512,45.4230225 C33.7778794,45.4230225 33.5957548,49.8171008 35.1723631,55.3028115 C36.6603703,60.4810547 39.5413844,64.2710211 42.044367,64.0530882 C42.0586417,64.0816212 42.0719318,64.1106461 42.0862065,64.1391791 C42.1472428,64.2611822 42.2087714,64.3792496 42.2707922,64.4953493 C42.3077094,64.564222 42.3303519,64.6380142 42.339212,64.7162339 C43.3955346,73.9107396 47.7960586,81.8788192 54.0773882,86.9262043 C54.2230879,87.0432879 54.3151346,87.2174374 54.324487,87.4038857 C54.8595395,98.1721326 43.5180996,102.489467 43.5180996,102.489467 C43.5180996,102.489467 24.2596543,110.237646 11.0925384,116.940436 C-0.571803507,122.878246 -0.164730428,136.392546 0.0799072022,139.399824 C0.107964234,139.740252 0.392472384,140 0.734571284,140 L139.265921,140 C139.60802,140 139.892528,139.740252 139.920093,139.399332 C140.16473,136.392054 140.571804,122.877754 128.907462,116.939944"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultProfileAvatar);
export default __webpack_public_path__ + "static/media/default_profile_avatar.9275dc628344969256669a17091c5108.svg";
export { ForwardRef as ReactComponent };